import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface ClearSearchButtonProps {
  onClear: () => void;
}

export default function ClearSearchButton(props: ClearSearchButtonProps): JSX.Element {
  return (
    <div onClick={props.onClear} className={css(styles.clear)}>
      <BenchlingIcon icon="cross-thick" className={css(styles.clearIcon)} />
      Clear
    </div>
  );
}

const styles = StyleSheet.create({
  clear: {
    cursor: 'pointer',
    color: Colors.GRAY_DARKER,
    flex: 'none',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  clearIcon: {
    marginRight: 4,
    fontSize: 9,
  },
});
